module.exports = __webpack_public_path__ + "img/share-vehicle2.71e00338.svg";